import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import PageWrapper from "../components/PageWrapper";
import {Section, Title, Text, Box} from "../components/Core";
import {useTranslation} from "gatsby-plugin-react-i18next";

const TermsConditions = () => {
    const {t} = useTranslation('conditions');
    return (
        <>
            <PageWrapper footerDark>
                <Section>
                    <div className="pt-5"/>
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg="9" xl="8">
                                <Title variant="hero" className="text-center">
                                    {t('title')}
                                </Title>
                                <Box mt={["40px", null, "50px"]}>
                                    <Title variant="card" fontSize="2rem" mb="30px">
                                        {t('editor-title')}
                                    </Title>
                                    <Text variant="small">
                                        {t('editor-text')}
                                    </Text>
                                    <Text variant="small">
                                        {t('editor-text-2')}
                                    </Text>
                                    <Text variant="small">
                                        {t('editor-text-3')}
                                    </Text>
                                    <Text variant="small">
                                        {t('editor-text-4')}
                                    </Text>
                                    <Text variant="small">
                                        {t('editor-text-5')}
                                    </Text>
                                </Box>

                                <Box mt={["40px", null, "50px"]}>
                                    <Title variant="card" fontSize="2rem" mb="30px">
                                        {t('hosting-title')}
                                    </Title>
                                    <Text variant="small">
                                        {t('hosting-text')}
                                    </Text>
                                </Box>
                                <Box mt={["40px", null, "50px"]}>
                                    <Title variant="card" fontSize="2rem" mb="30px">
                                        {t('intellectual-property-title')}
                                    </Title>
                                    <Text variant="small">
                                        {t('intellectual-property-text')}
                                    </Text>
                                </Box>
                                <Box mt={["40px", null, "50px"]}>
                                    <Title variant="card" fontSize="2rem" mb="30px">
                                        {t('privacy-policies-title')}
                                    </Title>
                                    <Text variant="small">
                                        {t('privacy-policies-text')}
                                    </Text>
                                </Box>
                                <Box mt={["40px", null, "50px"]}>
                                    <Title variant="card" fontSize="2rem" mb="30px">
                                        {t('credits-title')}
                                    </Title>
                                    <Text variant="small">
                                        {t('credits-text')}
                                    </Text>
                                </Box>
                            </Col>
                        </Row>
                    </Container>
                </Section>
            </PageWrapper>
        </>
    );
};

export default TermsConditions;
